<template>
  <PluginItemAction
    v-if="isEditing"
    id="edit"
    :title="$t('edit', 'Edit')"
    :disabled="!canEdit"
    meta
    key-code="E"
    icon="edit"
    :weight="-100"
    @click="onClick"
  />
</template>

<script setup>
import { computed, useBlokkli, defineBlokkliFeature } from "#imports";
import { PluginItemAction } from "#blokkli/plugins";
import onBlokkliEvent from "#blokkli/helpers/composables/onBlokkliEvent";
defineBlokkliFeature({
  id: "edit",
  icon: "edit",
  label: "Edit",
  description: "Provides an action to edit a block.",
  requiredAdapterMethods: ["formFrameBuilder"]
});
const { eventBus, selection, state, $t, adapter, definitions } = useBlokkli();
const block = computed(() => {
  if (selection.blocks.value.length !== 1) {
    return null;
  }
  return selection.blocks.value[0];
});
const isEditing = computed(() => state.editMode.value === "editing");
const canEdit = computed(() => {
  if (!block.value) {
    return false;
  }
  const definition = definitions.getBlockDefinition(
    block.value.itemBundle,
    block.value.hostFieldListType,
    block.value.parentBlockBundle
  );
  if (definition?.editor?.disableEdit) {
    return false;
  }
  if (block.value.libraryItemUuid) {
    return !!adapter.getLibraryItemEditUrl && (state.editMode.value === "editing" || state.editMode.value === "translating") && !block.value.isNew;
  }
  return state.editMode.value === "editing";
});
function onClick(items) {
  if (items.length !== 1) {
    return;
  }
  if (!canEdit.value) {
    return;
  }
  const item = items[0];
  if (item.libraryItemUuid && adapter.getLibraryItemEditUrl) {
    const url = adapter.getLibraryItemEditUrl(item.libraryItemUuid);
    eventBus.emit("library:edit-item", {
      url,
      label: item.editTitle,
      uuid: item.libraryItemUuid
    });
    return;
  }
  eventBus.emit("item:edit", {
    uuid: item.uuid,
    bundle: item.itemBundle
  });
}
onBlokkliEvent("item:doubleClick", function(block2) {
  onClick([block2]);
});
</script>

<script>
export default {
  name: "Edit"
};
</script>
